import { render, staticRenderFns } from "./clothList.vue?vue&type=template&id=78f63e12"
import script from "./clothList.vue?vue&type=script&lang=js"
export * from "./clothList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports